export enum PET_TYPE {
    DOG = 'dog',
    CAT = 'cat',
    DOG_AND_CAT = 'dog-and-cat',
    OTHER = 'other',
}
